import { FC } from "react"
import { ColSize, ContentSection, InputForm, RadioForm, RowSize } from "../../../../../../../shared/components"
import { IntermediaryInformation } from "../../../../../../../shared/interfaces/services/get-producer-information-service";
import { OPTION_YES_OR_NOT } from "../../../../../../../shared/interfaces";


interface CommunicationChannelsFormProperties {
    intermediaryInformation:IntermediaryInformation;
}

export const CommunicationChannelsForm: FC<CommunicationChannelsFormProperties> = ({intermediaryInformation}) => {
    const {
        telefonoParticular,
        telefonoLaboral,
        muestraMails,
        muestraTelefonos
    } = intermediaryInformation;

    const radioFields = [
        { name: "showNumberProducer", label: "¿Desea que el asegurado vea sus números telefónicos?", value: muestraTelefonos },
        { name: "showEmailProducer", label: "¿Desea que el asegurado vea sus emails?", value: muestraMails }
    ];

    const formInputs = [
        { name: "workPhoneNumber", label: "Telefono Laboral", value: telefonoLaboral},
        { name: "personalPhoneNumber", label: "Telefono Particular", value: telefonoParticular}
    ];

    const capitalizeFirstLetter = (str: string): string => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    return (
        <div id="canales-comunicacion">
            <ContentSection level='h3' title='Canales de Comunicación'>
                <RowSize>
                    {radioFields.map(({ name, label, value }) => (
                        <ColSize key={name} size={25}>
                            <RadioForm
                                formProps={{
                                    initialValue: value,
                                    label: label,
                                    name: name,
                                }}
                                options={OPTION_YES_OR_NOT}
                            />
                        </ColSize>
                    ))}

                    {formInputs.map(({ label, name, value }) => (
                        <ColSize key={name} size={25}>
                            <InputForm
                                formProps={{
                                    label: label,
                                    name: name,
                                    initialValue: value
                                }}
                                inputProps={{ disabled: true }}
                            />
                        </ColSize>
                    ))}

                    {intermediaryInformation.correos.map(({ descripcionTipo, direccionCorreo  }) => (
                        <ColSize key={descripcionTipo} size={25}>
                            <InputForm
                                formProps={{
                                    label: `Email ${capitalizeFirstLetter(descripcionTipo)}`,
                                    name: descripcionTipo,
                                    initialValue: direccionCorreo
                                }}
                                inputProps={{ disabled: true }}
                            />
                        </ColSize>
                    ))}
                </RowSize>
            </ContentSection>
        </div>
    )
}